var stringManager = {
	get: function (name) {
		if (qdesk && qdesk.strings) {
			return qdesk.strings[name] || name;
		}
		return name;
	},

	format: function (format) {
		var args = Array.prototype.slice.call(arguments, 1);

		if (Array.isArray(args[0])) {
			args = args[0];
		}

		return this.get(format).replace(/{(\d+)}/g, function (match, number) {
			return typeof args[number] != 'undefined'
				? stringManager.get(args[number])
				: match
				;
		});
	}
};
export default stringManager;